import { Alert, Box, CircularProgress, createTheme, FormControl, InputLabel, Modal, Snackbar, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorHandling } from "../../components/Errors/Errors";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../components/Inputs/InputText";
import Lista from "../../components/Lista";
import { Popup } from "../../components/Popup/Popup";
import { PopupExtraG } from "../../components/Popup/PopupExtraG";
import servSolicitacaoAcesso from "../../services/login/servSolicitacaoAcesso";
import { style as modalStyle } from "../../components/Loading/Loading";
import { OpcoesPeriodoDatas } from '../../components/Combobox/PeriodoDatas'
import { logout } from "../../state/slices/userSlice";
import { setCurrentSolicitacao } from "../../state/slices/analisesSlice";
import Cadastro from "./Cadastro";
import { columnsSolicitacaoAcesso } from "./Lista";
import styles from "./SolicitacaoAcesso.module.css";
import { changeTab, newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";
import EnviarSolicAnalise from "./EnviarSolicAnalise";
import servAnalises from "../../services/login/servAnalises";
import ArquivarSolicitacao from "./ArquivarSolicitacao";
import ArquivamentoSolic from "./ArquivamentoSolic";
import InicioInstalacao from "./InicioInstalacao";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OpcoesSituacaoSolicAcesso } from "../../components/Combobox/SituacaoSolicAcesso";
import { SearchFieldStyles } from "../../components/Searchfields/SearchFieldStyles";
import Select from 'react-select';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";
import { retornaDatasCfeTipoPeriodo } from "../../infra/utils/RetornaDatasCfeTipoPeriodo";
import { SearchFieldStylesFiltro } from "../../components/Searchfields/SearchFieldStylesFiltro";
import servFileIni from "../../services/login/servFileIni";

const SolicitacaoAcesso = () => {
    // Store e Navegação
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const tabs = useSelector(state => state.tabs);
    const navigate = useNavigate();

    const [filtro, setFiltro] = useState("");
    const [filtroCodigo, setFiltroCodigo] = useState("");
    const [situacaoSolicAcesso, setSituacaoSolicAcesso] = useState([]);
    const [solicitacoes, setSolicitacoes] = useState([]);

    const [tipoPeriodo, setTipoPeriodo] = useState({ value: 8, label: 'Este mês' });
    const [tipoDataFiltro, setTipoDataFiltro] = useState("data-cadastro");
    const [dataInicialFiltro, setDataInicialFiltro] = useState(new Date());
    const [dataFinalFiltro, setDataFinalFiltro] = useState(new Date());

    const [openCadastro, setOpenCadastro] = useState(false);
    const [eNovoCadastro, setENovoCadastro] = useState(false);
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [podeVisualizarArquivamento, setPodeVisualizarArquivamento] = useState(false);
    const [podeSolicitarArquivamento, setPodeSolicitarArquivamento] = useState(false);
    const [podeEnviarAnalise, setPodeEnviarAnalise] = useState(false);
    const [podeInformarInstalacao, setPodeInformarInstalacao] = useState(false);
    const [tabResultadoAnalise, setTabResultadoAnalise] = useState(false);

    const [openAnalise, setOpenAnalise] = useState(false);
    const [openArquivamento, setOpenArquivamento] = useState(false);
    const [openVisualizarArquivamento, setOpenVisualizarArquivamento] = useState(false);
    const [openInicioInstalacao, setOpenInicioInstalacao] = useState(false);

    const [resultadoAnalise, setResultadoAnalise] = useState(null);
    const [openResultadoAnalise, setOpenResultadoAnalise] = useState(false);

    // Carregamento e modais
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);

    const theme = createTheme({
        components: {
            MuiIconButton: {
                styleOverrides: {
                    sizeMedium: {
                        color: "#d2d4d2"
                    }
                }
            }
        }
    });

    // Chamadas a API
    // Listar inicial
    useEffect(() => {
        const recuperarDados = async (filtroDatas) => {
            try {
                setIsLoading(true);

                let dados;

                // Se não tiver situação ou data informada, faz o listar básico, só com a pesquisa geral
                if (!filtroDatas) {
                    dados = await servSolicitacaoAcesso.listarCFiltros(user.codigoUsuario, "");
                } else {
                    let arraySituacoes = [];

                    arraySituacoes = situacaoSolicAcesso.map((item) => item.value);

                    dados = await servSolicitacaoAcesso.listarCfeSituacaoOuData(user.codigoUsuario,
                        filtro,
                        filtroCodigo,
                        arraySituacoes,
                        tipoDataFiltro,
                        filtroDatas.dataInicial,
                        filtroDatas.dataFinal);
                }

                let content = dados?.Content;

                if (dados.Content.length === 0) {
                    return setIsLoading(false);
                }

                content && content.map((solicitacao) => {
                    return solicitacao.id = solicitacao.Id
                });

                setSolicitacoes(content);

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status,
                    err?.Message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        const recuperarUltimoTipoPeriodoDefinido = async () => {
            try {
                setIsLoading(true);

                let dto = {
                    CodigoUsuario: user.codigoUsuario.toString(),
                    CodigoSecao: "TIPO_PERIODO_P3",
                    Chave: "IDTIPOPERIODOSOLICACESSO",
                    Conteudo: ""
                };

                let response = await servFileIni.Recuperar(dto);
                let novasDatas;

                if (response.Content.trim() !== "") {
                    let conteudo = Number(response.Content);
                    let labelTipoPeriodo = OpcoesPeriodoDatas.find((periodo) => periodo.value === conteudo).label;

                    await setarTipoPeriodoERedefinirDatas({ value: conteudo, label: labelTipoPeriodo });
                    novasDatas = retornaDatasCfeTipoPeriodo(conteudo);
                } else {
                    await setarTipoPeriodoERedefinirDatas({ value: 8, label: "Este mês" });
                    novasDatas = retornaDatasCfeTipoPeriodo(8); // 8 - Este mês
                }

                if (solicitacoes.length === 0) {
                    recuperarDados(novasDatas);
                }

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status,
                    err?.Message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        recuperarUltimoTipoPeriodoDefinido();
    }, []);

    useEffect(() => {
        if (recordForEdit === null) {
            setPodeEnviarAnalise(false);
            setPodeVisualizarArquivamento(false);
            setPodeSolicitarArquivamento(false);
            setPodeInformarInstalacao(false)
            return;
        }

        let situacao = recordForEdit?.Situacao || (recordForEdit?.row?.Situacao ?? 0);

        const situacaoPodeEnviarAnalise = [0, 2];
        const situacaoArquivada = [5];
        const situacaoPodeIniciarInstalacao = [4];

        situacaoPodeEnviarAnalise.includes(situacao) ? setPodeEnviarAnalise(true) : setPodeEnviarAnalise(false);
        situacaoArquivada.includes(situacao) ? setPodeVisualizarArquivamento(true) : setPodeVisualizarArquivamento(false);
        situacaoArquivada.includes(situacao) ? setPodeSolicitarArquivamento(false) : setPodeSolicitarArquivamento(true);
        situacaoPodeIniciarInstalacao.includes(situacao) ? setPodeInformarInstalacao(true) : setPodeInformarInstalacao(false);
    }, [recordForEdit]);

    const onClickPesquisar = async () => {
        try {
            setIsLoading(true);
            let dados;

            if (situacaoSolicAcesso.length === 0 &&
                (!dataInicialFiltro || dataInicialFiltro.toLocaleDateString() === "") &&
                (!dataFinalFiltro || dataFinalFiltro.toLocaleDateString() === "")) {
                dados = await servSolicitacaoAcesso.listarCFiltros(user.codigoUsuario, filtro);
            } else {
                let arraySituacoes = [];

                arraySituacoes = situacaoSolicAcesso.map((item) => item.value);

                dados = await servSolicitacaoAcesso.listarCfeSituacaoOuData(user.codigoUsuario,
                    filtro,
                    filtroCodigo,
                    arraySituacoes,
                    tipoDataFiltro,
                    dataInicialFiltro,
                    dataFinalFiltro);
            }

            let content = dados?.Content;

            content && content.map((solicitacao) => {
                return solicitacao.id = solicitacao.Id
            });

            setIsLoading(false);

            setSolicitacoes(content);

            if (content.length === 0) {
                setErrorMessage("Não foram encontrados registros para sua pesquisa");
                setOpenError(true);
            }
        } catch (err) {
            setIsLoading(false);

            return ErrorHandling(
                err?.response?.status,
                err?.Message,
                setOpenError,
                setErrorMessage,
                dispatch,
                logout,
                navigate,
                err?.response?.data?.Message);
        }
    }

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
        }

        setOpenError(false);
    }

    const adicionarNovaSolicitacao = () => {
        setENovoCadastro(true);
        setOpenCadastro(true);
    }

    const abrirSolicitacaoExistente = () => {
        setENovoCadastro(false);
        setOpenCadastro(true);
        setTabResultadoAnalise(false)
    }

    const solicitarAnalise = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const situacoesHomologaveis = [0, 2];

        if (situacoesHomologaveis.includes(recordForEdit?.row?.Situacao)
            || situacoesHomologaveis.includes(recordForEdit?.Situacao)) {
            return setOpenAnalise(true);
        }

        setErrorMessage("Só é possível solicitar análise de solicitações com situação em digitação ou revisão");
        return setOpenError(true);
    }

    const onClickAbrirAnalisesAntigas = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const situacaoSemAnalise = 0;

        if (recordForEdit?.row?.Situacao === situacaoSemAnalise
            || recordForEdit?.Situacao === situacaoSemAnalise) {
            setErrorMessage("A solicitação ainda não foi enviada para análise, portanto não possui análises realizadas");
            return setOpenError(true);
        }

        const listaSolicitacaoAc = {
            Nome: "Análises do orçamento de conexão",
            Aba: 5
        }

        let id = recordForEdit?.row?.Id || recordForEdit?.Id;

        dispatch(newTab(listaSolicitacaoAc));
        dispatch(setTabFromNewIndex(listaSolicitacaoAc.Aba));
        dispatch(setCurrentSolicitacao(id));

    }

    const abrirAnaliseSolicitacao = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const situacaoSemAnalise = 0;

        if (recordForEdit?.row?.Situacao === situacaoSemAnalise
            || recordForEdit?.Situacao === situacaoSemAnalise) {
            setErrorMessage("A solicitação ainda não foi enviada para análise, portanto não possui análises realizadas");
            return setOpenError(true);
        }

        setIsLoading(true);

        setENovoCadastro(false);
        setOpenCadastro(true);
        setTabResultadoAnalise(true)

        setIsLoading(false);

        setIsLoading(false);
    }

    const solicitarArquivamento = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        const situacoesAquivaveis = [0, 1, 2, 4];

        if (situacoesAquivaveis.includes(recordForEdit?.row?.Situacao)
            || situacoesAquivaveis.includes(recordForEdit?.Situacao)) {
            return setOpenArquivamento(true);
        }

        setErrorMessage("Não é possível arquivar solicitações já arquivadas.");
        return setOpenError(true);
    }

    const informarInicioInstalacao = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        const situacaoPodeInformarInicioInstalacao = [4];

        if (situacaoPodeInformarInicioInstalacao.includes(recordForEdit?.row?.Situacao)
            || situacaoPodeInformarInicioInstalacao.includes(recordForEdit?.Situacao)) {
            return setOpenInicioInstalacao(true);
        }

        setErrorMessage("Não é possível informar o início de instalação em solicitações ainda não analisadas.");
        return setOpenError(true);
    }

    const visualizarArquivamento = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        return setOpenVisualizarArquivamento(true);
    }

    const handleTipoDataFiltro = (event) => {
        event.preventDefault();

        setTipoDataFiltro(event.target.value)
    }

    const setarTipoPeriodoERedefinirDatas = async (tipoPeriodo) => {
        try {
            setTipoPeriodo(tipoPeriodo);

            let datasCalculadas = retornaDatasCfeTipoPeriodo(tipoPeriodo?.value);
            setDataInicialFiltro(datasCalculadas.dataInicial);
            setDataFinalFiltro(datasCalculadas.dataFinal);

            let dto = {
                Chave: "IDTIPOPERIODOSOLICACESSO",
                Conteudo: tipoPeriodo.value.toString(),
                CodigoSecao: "TIPO_PERIODO_P3",
                CodigoUsuario: user.codigoUsuario.toString()
            };

            await servFileIni.Inserir(dto);
        } catch (err) {
            setIsLoading(false);
            setErrorMessage("Erro ao salvar tipo de período. Tente novamente.");
            setOpenError(true);
            return;
        }
    }

    return (
        <div className={styles.solicitacaoContainer}>
            <div className={styles.solicitacaoFiltros}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Pesquisa geral<FontAwesomeIcon title="Este campo pesquisa por: código do orçamento de conexão, protocolo, nome, UC ou inscrição." style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer" }} icon={faQuestionCircle} /></InputLabel>
                    <WhiteInput value={filtro} onChange={(e) => setFiltro(e.target.value)} placeholder="Pesquisa" id="pesquisa-nome" sx={{ width: "500px", margin: '0px 18px' }} />
                </FormControl>
            </div>
            <div className={styles.solicitacaoFiltros} style={{ marginTop: "20px" }}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Orç. de conexão</InputLabel>
                    <WhiteInput value={filtroCodigo} onChange={(e) => setFiltroCodigo(e.target.value)} placeholder="Orç. de conexão" id="pesquisa-codigo" sx={{ width: "200px", margin: '0px 18px' }} />
                </FormControl>
                <FormControl variant="outlined" sx={{ width: "450px", marginRight: "20px" }}>
                    <InputLabel htmlFor="pesquisa-nome-situacao" shrink style={{ color: "#B8B8B8" }}>
                        Situação
                    </InputLabel>
                    <Select
                        isMulti={true}
                        value={situacaoSolicAcesso}
                        onChange={value => setSituacaoSolicAcesso(value)}
                        options={OpcoesSituacaoSolicAcesso}
                        styles={SearchFieldStyles}
                        placeholder="Situação"
                    />
                </FormControl>
            </div>
            <div className={styles.solicitacaoFiltros}>
                <FormControl variant="outlined">
                    <InputLabel htmlFor="data-solicitacao" shrink style={{ color: "#B8B8B8", marginTop: "20px", marginLeft: "10px" }} >
                        <select className={styles.tipoDataFiltroConsulta} name="tipo-data" id="tipo-data" value={tipoDataFiltro} onChange={handleTipoDataFiltro}>
                            <optgroup>
                                <option value="data-cadastro" selected>Data cadastro</option>
                                <option value="data-envio-homolog">Data envio homolog.</option>
                            </optgroup>
                        </select>
                    </InputLabel>
                    <div className={styles.solicitacaoAcessoDatas}>
                        <Select
                            value={tipoPeriodo}
                            onChange={(e) => setarTipoPeriodoERedefinirDatas(e)}
                            options={OpcoesPeriodoDatas}
                            styles={SearchFieldStylesFiltro}
                            placeholder="Período"
                        />
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataInicialFiltro}
                                    onChange={(e) => setDataInicialFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 250, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                        <span style={{ color: "whitesmoke", margin: "9px 5px" }}>-</span>
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataFinalFiltro}
                                    onChange={(e) => setDataFinalFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 30, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                    </div>
                </FormControl>
                <BlueHoverButton variant="contained" onClick={onClickPesquisar} style={{ marginTop: "16.5px" }}>
                    Pesquisar
                </BlueHoverButton>
            </div>

            <div className={styles.solicitacaoBotoes}>
                <BlueHoverButton variant="contained" onClick={adicionarNovaSolicitacao}>Novo orçamento</BlueHoverButton>
                {podeEnviarAnalise && (
                    <BlueHoverButton variant="contained" onClick={solicitarAnalise}>Enviar para análise</BlueHoverButton>
                )}
                <BlueHoverButton variant="contained" onClick={abrirAnaliseSolicitacao}>Resultado análise</BlueHoverButton>
                <BlueHoverButton variant="contained" onClick={onClickAbrirAnalisesAntigas}>Resultados anteriores</BlueHoverButton>
                {podeInformarInstalacao && (
                    <BlueHoverButton variant="contained" onClick={informarInicioInstalacao}>Informar início de instalação</BlueHoverButton>
                )}
                {podeSolicitarArquivamento && (
                    <BlueHoverButton variant="contained" onClick={solicitarArquivamento}>Arquivar</BlueHoverButton>
                )}
                {podeVisualizarArquivamento && (
                    <BlueHoverButton variant="contained" onClick={visualizarArquivamento}>Arquivamento</BlueHoverButton>
                )}
            </div>
            <div className={styles.solicitacaoLista}>
                <Lista
                    columns={columnsSolicitacaoAcesso}
                    rows={solicitacoes}
                    onDblClick={abrirSolicitacaoExistente}
                    setSelectedData={setRecordForEdit}
                    hideFooter={false}
                    autoHeight={false}
                />
            </div>

            <PopupExtraG
                title="Orçamento de conexão"
                openPopup={openCadastro}
                setOpenPopup={setOpenCadastro}
                novoCadastro={eNovoCadastro}
                setNovoCadastro={setENovoCadastro}
            >
                <Cadastro
                    // addOrdEdit={adicionarOuEditar}
                    pesquisar={onClickPesquisar}
                    recordForEdit={recordForEdit}
                    setRecordForEdit={setRecordForEdit}
                    setOpen={setOpenCadastro}
                    novoCadastro={eNovoCadastro}
                    setEhNovoCadastro={setENovoCadastro}
                    tabResultadoAnalise={tabResultadoAnalise}
                    key={"SolicitacaoAcesso"}
                />
            </PopupExtraG>

            <Popup title="Enviar orçamento para análise" openPopup={openAnalise} setOpenPopup={setOpenAnalise} minHeight="100px" >
                <EnviarSolicAnalise
                    setOpenPopup={setOpenAnalise}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                />
            </Popup>

            <Popup title="Início de instalação" openPopup={openInicioInstalacao} setOpenPopup={setOpenInicioInstalacao} minHeight="100px">
                <InicioInstalacao
                    setOpenPopup={setOpenInicioInstalacao}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                />
            </Popup>

            <Popup title="Arquivar orçamento de conexão" openPopup={openArquivamento} setOpenPopup={setOpenArquivamento} minHeight="100px">
                <ArquivarSolicitacao
                    setOpenPopup={setOpenArquivamento}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                />
            </Popup>

            <Popup title="Arquivamento" openPopup={openVisualizarArquivamento} setOpenPopup={setOpenVisualizarArquivamento} minHeight="100px">
                <ArquivamentoSolic
                    setOpenPopup={setOpenVisualizarArquivamento}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                />
            </Popup>

            <Modal open={isLoading} >
                <Box style={modalStyle} >
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>

            <Snackbar open={openError} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={6000} onClose={handleCloseError}>
                <Alert onClose={handleCloseError} severity="error" sx={{ width: "100%" }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}

export { SolicitacaoAcesso };